
import { Vue, Component } from 'vue-property-decorator'
import { ClueService } from '@/services'

@Component({})
export default class SourceSetting extends Vue {
    private pageSize = 10
    private pageTotal = 0
    private pageIndex = 1
    private isLoading = false
    private sourceList = []
    private channelInfo = {
        id: '',
        name: ''
    }

    private created() {
        const { id } = this.$route.params
        const { name } = this.$route.query
        this.channelInfo.id = id
        this.channelInfo.name = decodeURIComponent(name as string)
    }

    private mounted() {
        this.initData()
    }

    private async initData() {
        const params = {
            channel_id: +this.channelInfo.id,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        this.isLoading = true
        const result = await ClueService.getChannelSourceList(params)
        this.isLoading = false
        if (result.status === 200) {
            this.sourceList = result.data.list
            this.pageTotal = result.data.page_total
        }
    }

    private async deleteSource(id: number) {
        const params = { id }
        console.log('删除数据源，参数:', params)
        this.isLoading = true
/*
        const result = await ClueService.deleteChannelSource(params)
        this.isLoading = false
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '数据源删除成功',
                showClose: true
            })
            return true
*/
        try {
            const result = await ClueService.deleteChannelSource(params)
            console.log('删除结果:', result)
            this.isLoading = false
            if (result.status === 200) {
                this.$message({
                    type: 'success',
                    message: '数据源删除成功',
                    showClose: true
                })
                return true
            }
        } catch (err) {
            console.error('删除出错:', err)
            this.isLoading = false

        }
        return false
    }

    private onAddSource() {
        this.$router.push({
            name: 'SourceSetting',
            params: {
                type: 'add'
            },
            query: {
                id: this.channelInfo.id
            }
        })
    }

    private onSourceDelete({ id }: any) {
        this.$confirm('是否确定删除此数据源?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            let result = await this.deleteSource(id)
            result && await this.initData()
            this.isLoading = false
        }).catch()
    }

    private onUpdateConfig({ id }: any) {
        this.$router.push({
            name: 'SourceSetting',
            params: {
                type: 'update'
            },
            query: {
                id: this.channelInfo.id,
                sid: id
            }
        })
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.initData()
    }

}
